import Link from "next/link";
import { LuExternalLink } from "react-icons/lu";

import { DIALOG, setDialog } from "@/components/app/dialogs/dialog-provider";
import DesoAvatar from "@/components/shared/deso-avatar";
import { UserDisplayNameWithStatus } from "@/components/shared/user-display-name-with-status";
import { Button } from "@/components/ui/button";
import type { PartialAccount } from "@/utils/types";
import { getUserName } from "@/utils/usernames";

export const TokenDetailsHeader = (account: PartialAccount) => {
  const username = account.username || "";

  return (
    <div
      className="
        flex flex-row flex-wrap items-center justify-between gap-2 pb-4
      "
    >
      <div
        className="
          mb-2 flex items-center gap-3
          md:mb-0
        "
      >
        <DesoAvatar
          {...{
            account,
            size: 60,
          }}
        />
        <div className="flex flex-col gap-1">
          <UserDisplayNameWithStatus
            account={account}
            className="font-sans text-base"
            whaleSize={20}
          />
          <div className="flex items-center gap-2 text-sm text-muted">
            {getUserName({
              customPrefix: "$",
              account,
            })}
          </div>
        </div>
      </div>

      <div className="mt-4 mb-2 grid w-full grid-cols-2 gap-4">
        <Link href={`/${username}`}>
          <Button variant="outline" size="sm" className="w-full">
            View Details
          </Button>
        </Link>

        <Button
          variant="default"
          size="sm"
          className="flex w-full items-center justify-center gap-2"
          onClick={() =>
            setDialog(DIALOG.GetTokensEarly, {
              open: true,
              params: {
                username,
              },
            })
          }
        >
          Get Tokens Early
          <LuExternalLink />
        </Button>
      </div>
    </div>
  );
};
